import { v4 as uuid } from 'uuid';
import { Vendor } from '../../api/gql';
import { Contact } from './contact';

export type XmlVendorData = Partial<Vendor>;
export class XmlVendor extends Contact {
  #details: XmlVendorData;
  constructor(details: XmlVendorData, invoiceId?: string) {
    super(details.id || uuid(), invoiceId);
    this.#details = details;
  }
  get details() {
    return this.#details;
  }

  set details(details) {
    this.#details = details;
  }
}
